export default "__VITE_ASSET__CvlZtVvD__"